import * as React from "react";
import { Grid, TextField } from "@mui/material";

import moment from "moment";

export default function SmartLockTemporaryPasswordCreateForm({password, passwordName, startDate, endDate, errors, handleChangeStart, handleChangeEnd, handleChangePassword, handleChangePasswordName}) {
  return (
    <Grid container component="form" noValidate autoComplete="off" spacing={2} sx={{ padding:"10px" }}>
      <Grid item xs={12} sm={12}>
        <TextField size="small" name="passwordName" fullWidth value={passwordName} onChange={handleChangePasswordName} helperText={errors.passwordName} error={Boolean(errors.passwordName)} label="Password Name" />
      </Grid>

      <Grid item xs={12} sm={12}>
        <TextField size="small" name="password" fullWidth value={password} onChange={handleChangePassword} type="number"  label="Add Password of strictly 7 digits" helperText={errors.password} error={Boolean(errors.password)}  />
      </Grid>
      
      <Grid item xs={12} sm={12}>
        <TextField size="small" name="startDate" fullWidth value={startDate} type="datetime-local"  onChange={handleChangeStart} label="Start Time" helperText={errors.startDate} error={Boolean(errors.startDate)}  />
      </Grid>
      
      <Grid item xs={12} sm={12}>
        <TextField size="small" name="endDate" fullWidth value={endDate} type="datetime-local" onChange={handleChangeEnd} label="End Time" helperText={errors.endDate} error={Boolean(errors.endDate)}  />
      </Grid>
    </Grid>
  );
}
